export function randomId(): string {
  const cryptoApi = globalThis.crypto;

  if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }

  throw new Error("Secure randomUUID is unavailable in this runtime.");
}
